import { api } from "./api";

const API = process.env.REACT_APP_API;

/**
 * POST /api/users/me/send-desktop-url
 *
 * Emails the signed-in user a link back into the dashboard, for when they open
 * it on a phone. Takes no payload — the recipient is the bearer of the token.
 */
export async function sendDesktopUrl(): Promise<void> {
  await api.post(
    `${API}/api/users/me/send-desktop-url`,
    {},
    { headers: { "Content-Type": "application/json" } }
  );
}
